<div class="modal-body">
  <div class="text-right">
    <i class="fa-solid fa-times pointer" (click)="dismiss()"></i>
  </div>
  <div class="d-flex justify-content-between w-100 flex-sm-row flex-column">
    <div class="img-width">
      <img src="../../../assets/webbtree-freemium/skill-taxonomy.png" class="img-fluid" alt="">
    </div>
    <div class="d-flex flex-column justify-content-center content-width">
      <div class="mb-8">
      <p class="f-20 font-weight-600 text-black mb-3">Unlock the Full Skill Taxonomy</p>
      <p class="f-14 font-weight-normal text-black mb-0"> You’re seeing a preview of the skills. Get the  <span class="font-weight-600">complete structured taxonomy</span> with all detailed skill clusters, percentages, and role insights delivered straight to your inbox.</p>
      </div>
      <form [formGroup]="freeTrialForm">
      <div>
        <p class="f-14 font-weight-600 text-black mb-3">To Get Detail Skill Taxonomy</p>
        <div class="d-flex responsive-column">
        <div class="mb-2 w-100">
          <input data-testid="auto-app-marketing-modal-input-1" type="email" formControlName="workEmail" form placeholder="Enter your work email" class="wc-form-control" id="workemailforfreetrial">
        </div>

          <button data-testid="auto-app-marketing-modal-button-1" class="btn-trms-medium btn-disable" (click)="requestFreeTrial()" [ngClass]="{'btn-active': freeTrialForm?.valid}">
             <span [ngClass]="{ 'spinner-border text-light spinner-size': showFreeTrialLoader}" [ngStyle] = "{ 'width: 250px; height: 20px;': showFreeTrialLoader }">
                    {{showFreeTrialLoader ? '' : 'Unlock'}}
                  </span>
                </button>
        </div>
      </div>
         <div class="posrelativeinmobile">
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;"
                 *ngIf="freeTrialForm['controls'].workEmail.hasError('required') && (freeTrialForm['controls'].workEmail.dirty || freeTrialForm['controls'].workEmail.touched)">
                  This field is required</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('pattern')">
                  Invalid Email Id</p>
                <p class="text-danger f-12 pt-1 mb-0" style="position: absolute;" *ngIf="freeTrialForm['controls'].workEmail.hasError('invaliDomain')">
                  Invalid Domain</p>

              </div>
               <div class="row">
          <div class="col">
            <p class="text-danger f-12 pt-1" *ngIf="showErrorMsg">{{showErrorMsg}}</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>


<ng-template #freeTrialSuccess>
  <div>
    <div class="text-center" style="padding: 50px;">
      <img src="../../../assets/images/freetrialsuccess.png" alt="" class="img-success">
      <p class="f-16 font-weight-600 green-color">Success!</p>
      <p class="f-14 font-weight-500">You’re all set!</p>
      <div>
        <p>Your detailed skill taxonomy is on its way to your inbox. Explore Core, Related, and Emerging skills with Webbtree’s Talent market data.
        </p>
      </div>
      <div>
        <button data-testid="auto-app-marketing-modal-button-2" class="btn-trms-small" (click)="modalService.dismissAll()">Close</button>

      </div>

    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

